<template>
  <div>
    <b-card>
      <b-row class="mb-1">
        <b-col md="12">
          <b-button
            v-if="!permissoes || permissoes.store.permissao"
            variant="primary"
            @click="$refs.anexoModal.show()"
          >
            Novo Anexo
          </b-button>
        </b-col>
      </b-row>
      <b-overlay
        :show="load"
        variant="transparent"
      >
        <b-row>
          <b-col md="12">
            <b-table
              responsive
              :fields="fields"
              :items="items"
            >
              <template #cell(actions)="data">
                <feather-icon
                  icon="EyeIcon"
                  class="color-icon cursor-pointer"
                  @click="preview(data.item)"
                />
              </template>

              <template #cell(status)="data">
                <b-badge :variant="statusVariant(data.item.status)">
                  {{ data.item.status }}
                </b-badge>
              </template>

              <template #cell(data)="data">
                {{ formatTimezone(data.item.data) }}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card>

    <b-modal
      id="preview"
      ref="preview"
      hide-footer
      size="xl"
      title=""
    >
      <iframe
        id="myFrame"
        :src="urlPreview"
      />
    </b-modal>

    <b-modal
      ref="anexoModal"
      no-close-on-backdrop
      title="Anexar arquivo"
      ok-title="Anexar"
      cancel-title="Cancelar"
      cancel-variant="danger"
      :ok-disabled="newPend.length === 0 || (pendenciaSelecionada && pendenciaSelecionada.length === 0) || !file"
      @ok="updatePend"
      @show="limparModal"
    >
      Operações:
      <v-select
        v-model="newPend"
        :options="optionsOperations.options"
        multiple
        class="mb-1"
      />
      Pendência:
      <v-select
        v-model="pendenciaSelecionada"
        :options="mtPend"
        class="mb-1"
      />
      Selecione o arquivo:
      <b-form-file
        v-model="file"
        placeholder=""
        drop-placeholder="Arquivo"
      />

    </b-modal>

  </div>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BButton,
  VBModal,
  BFormFile,
  BModal,
  BCard,
  BOverlay,
  BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import { mapState } from 'vuex'
import axios from '@/../axios-auth'

export default {
  components: {
    BTable,
    vSelect,
    BRow,
    BCol,
    BButton,
    BFormFile,
    BModal,
    BCard,
    BOverlay,
    BBadge,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    idCliente: {
      type: Number,
      required: true,
    },
    updateTabs: {
      type: Function,
      required: true,
    },

  },
  data() {
    return {
      newPend: [],
      optionsOperations: {
        options: [],
      },
      mtPend: [],
      permissoes: null,

      fields: [
        { key: 'id', label: 'ID', class: 'text-center' },
        { key: 'anexo', label: 'Anexo', class: 'text-center' },
        { key: 'status', label: 'Status', class: 'text-center' },
        { key: 'data', label: 'Data', class: 'text-center' },
        { key: 'actions', class: 'text-center' },
      ],
      items: [],
      file: null,
      urlPreview: '',
      load: false,
      pendenciaSelecionada: [],
    }
  },

  computed: {
    ...mapState({
      operacoesCliente: state => {
        const { operacoes } = state.negociacao
        return operacoes
      },
    }),
  },

  watch: {
    operacoesCliente() {
      this.getOperacoes()
    },
  },
  created() {
    this.loadPermissions()
    this.getAnexos()
    this.getPendingReason()
    this.optionsStatusOperations()
    this.getOperacoes()
  },
  methods: {
    loadPermissions() {
      const permissoes = JSON.parse(localStorage.getItem('permissoes'))
      if (permissoes && permissoes.anexos) {
        this.permissoes = permissoes.anexos
      }
    },

    statusVariant(status) {
      const map = {
        RECEBIDO: 'light-info',
        'EM ANÁLISE': 'light-warning',
        CONCLUÍDO: 'light-success',
      }
      return map[status] || 'light-secondary'
    },

    async getOperacoes() {
      this.optionsStatusOperations()
    },

    async getAnexos() {
      this.load = true
      this.items = []
      await axios.get(`api/v1/anexos/listar/${this.idCliente}`).then(res => {
        this.load = false
        if (res.data) {
          this.items = res.data.map(item => ({
            id: item.id,
            anexo: item.nome,
            data: item.created_at,
            url: item.url,
            status: item.status,
          }))
        }
      }).catch(() => {
        this.load = false
      })
    },

    async sendAnexo() {
      const formData = new FormData()
      formData.append('cliente_id', this.idCliente)
      formData.append('anexo', this.file)
      formData.append('user_id', Number(localStorage.getItem('userId')))
      formData.append('info_pendencia', JSON.stringify({
        id_operacao: this.newPend.map(item => item.id),
      }))

      await axios.post('api/v1/anexos/store', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        },
      }).then(() => {
        this.getAnexos()
        this.$swal({
          title: 'Sucesso!',
          text: 'Anexo enviado',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },
    async preview(item) {
      this.urlPreview = item.url
      this.$refs.preview.show()
    },

    async getPendingReason() {
      await axios.get('api/v1/info/motivopendencia', {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(res => {
        const pendenciasPermitidas = [15, 19]
        res.data.dados.map(dt => {
          if (pendenciasPermitidas.includes(dt.id)) {
            this.mtPend.push({
              id: dt.id,
              label: dt.nome,
            })
          }
        })
      })
    },

    async optionsStatusOperations() {
      this.operacoesCliente.map(item => {
        this.optionsOperations.options.push({
          label: `${item.numero_operacao} - ${item.data_vencimento}`,
          id: item.id,
          numero: item.numero_operacao,
          vencimento: item.data_vencimento,
        })
      })
    },

    async updatePend() {
      const operacoesIds = []
      this.newPend.map(id => {
        operacoesIds.push(id.id)
      })
      const body = {
        ops_ids: operacoesIds,
        motivo_pendencia_id: this.pendenciaSelecionada.id,
        description: '',
        motivoId: 12,
      }

      await axios.put('api/v1/operacoes/update/lote/motivo/pendencia/', body, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        },
      }).then(() => {
        this.$swal({
          title: 'Pendência alterada!',
          text: 'Alteração executada com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
        })
      }).catch(() => {
        this.$swal({
          title: 'ERROR!',
          text: 'Erro ao executar alteração!',
          icon: 'error',
          customClass: {
            comfirmButton: 'btn btn-danger',
          },
        })
      })
      await this.sendAnexo()
      await this.updateTabs()
      await this.sendLog()
    },
    limparModal() {
      this.newPend = []
      this.pendenciaSelecionada = []
    },
    // Função para alimentar  a tabela de log de anexos na primeira vez que o anexo é enviado, um anexo padrão
    async sendLog() {
      const arrayAnexo = this.items
      const arrayIdAnexo = []
      arrayAnexo.map(id => {
        arrayIdAnexo.push(id.id)
      })
      const arrayOrdenado = arrayIdAnexo.sort((a, b) => b - a)

      const ultimoIdAnexo = arrayOrdenado[0]

      const body = {
        anexo_id: ultimoIdAnexo,
        status: 'RECEBIDO',
        usuario: localStorage.getItem('userName'),
      }
      await axios.post('api/v1/log/anexos/store', body, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        },
      })
    },
  },
}
</script>
<style>
    #myFrame {
      width:100%;
      height:800px;
      border: none;
    }
</style>
